import React, { useState, useEffect } from 'react'
import Sidebar from './components/Sidebar'

const Contact = () => {
	const [tableData, setTableData] = useState([]);

	useEffect(() => {
		// Fetch data from the backend
		fetchData();
	}, []);

	// const URL = import.meta.env.VITE_BASE_URL;

	const fetchData = async () => {
	    try {
	      const response = await fetch(`${process.env.REACT_APP_API_URL}/contact`); // Replace with your backend endpoint
	      if (response.ok) {
	        const data = await response.json();
	        setTableData(data);
	      } else {
	        console.error('Error fetching data');
	      }
	    } catch (error) {
	      console.error('Error fetching data:', error);
	    }
	};

	return (
		<>
			<div className="flex">
		      <Sidebar />
		      <div className="w-[85%]">
		        <div className="px-5 py-4 bg-black text-white">
		          <p className="capitalize text-lg" style={{fontFamily: "Muli"}}>welcome, admin</p>
		        </div>
		        <div className="p-20">
		        	<div className="flex justify-center overflow-x-auto ">
					  <table className="min-w-full border border-gray-300">
					    <thead>
					      <tr className="bg-gray-100">
					        <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider" style={{fontFamily: "Muli"}}>Name</th>
					        <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider" style={{fontFamily: "Muli"}}>Email</th>
					        <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider" style={{fontFamily: "Muli"}}>Subject</th>
					        <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider" style={{fontFamily: "Muli"}}>Message</th>
					      </tr>
					    </thead>
					    <tbody className="bg-white divide-y divide-gray-300">
					      {/* Table rows */}
					      {tableData.length > 0 && tableData.map(contact => (
						    <tr className="hover:bg-gray-100" key={contact._id}>
						        <td className="px-6 py-4 whitespace-nowrap" style={{fontFamily: "Muli"}}>{contact.fullName}</td>
						        <td className="px-6 py-4 whitespace-nowrap" style={{fontFamily: "Muli"}}>{contact.email}</td>
						        <td className="px-6 py-4 whitespace-nowrap" style={{fontFamily: "Muli"}}>{contact.subject}</td>
						        <td className="px-6 py-4 whitespace-nowrap" style={{fontFamily: "Muli"}}>{contact.message}</td>
						    </tr>
					      ))}
					      {/* Add more rows as needed */}
					    </tbody>
					  </table>
					</div>

		        </div>
		      </div>
		    </div>
		</>
	)
}

export default Contact